<fieldset class="container">

    <div fxLayout="row" fxLayoutAlign="space-between">
        <ng-container *ngIf="searchBarEnabled">
            <input type="text" class="small search" [(ngModel)]="filterValue" (ngModelChange)="performSearch()" placeholder="Search" [disabled]="editIndex != -1">
        </ng-container>
        <ng-container *ngIf="header != null">
            <ng-container [ngTemplateOutlet]="header"></ng-container>
        </ng-container>
        <mat-icon class="add" *ngIf="_buttonConfig.create.show" (click)="buttonClick.emit({button: _buttonConfig.create.output}); createRow();">add</mat-icon>
    </div>

    <ng-container *ngIf="headerTwo != null">
        <ng-container [ngTemplateOutlet]="headerTwo"></ng-container>
    </ng-container>

    <div class="table-wrap">    
        <mat-table matSort [dataSource]="_dataSource" (matSortChange)="sortLog($event)" class="mat-elevation-z8">
        
            <ng-container [matColumnDef]="column" *ngFor="let column of definedColumns; let i = index;">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="header noselect">
                    <ng-container *ngIf="columnNames.length == 0">{{column}} </ng-container>
                    <ng-container *ngIf="columnNames.length !=0">{{columnNames[i]}}</ng-container>
                </mat-header-cell>
                <mat-cell *matCellDef="let element; let i = index;"> 
                    <ng-container *ngIf="(editIndex != i) || !editDefinition.hasOwnProperty(column)">
                        <span 
                            *ngIf="!displayDefinition.hasOwnProperty(column)" 
                            class="grid-text" 
                            [matTooltip]="getColumnValue(element, column, columnFormatters[column])" 
                            (click)="copyText(element, column)">
                                {{getColumnValue(element, column, columnFormatters[column])}}
                        </span>
                        <ng-container *ngIf="displayDefinition.hasOwnProperty(column)" [ngTemplateOutlet]="displayDefinition[column]" [ngTemplateOutletContext]="{$implicit: element, _column:column}"></ng-container>
                    </ng-container>
    
                    <ng-container *ngIf="(editIndex == i) && editDefinition.hasOwnProperty(column)">
                            <ng-container [ngTemplateOutlet]="editDefinition[column]" [ngTemplateOutletContext]="{$implicit: touchedDataElement}"></ng-container>
                    </ng-container>
                </mat-cell>
            </ng-container>
    
            <ng-container matColumnDef="buttons">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell  *matCellDef="let element; let i = index" class="button-cell">
                    <div fxLayout="row" fxLayoutAlign="end center">
                        <ng-container *ngIf="mouseIndex == i && editIndex == -1">
                            <mat-icon class="table-button" *ngIf="_buttonConfig.edit.show" (click)="editRow(i, element);">create</mat-icon>
                            <mat-icon class="table-button" *ngIf="_buttonConfig.delete.show" (click)="deleteRow(i, element);">delete</mat-icon>
                            <ng-container *ngFor="let key of customButtonKeys">
                                <span *ngIf="mouseIndex == i && editIndex == -1" >
                                    <span 
                                        class="custom-button-template"
                                        *ngIf="_buttonConfig[key].hasOwnProperty('template')" 
                                        (click)="buttonClick.emit({button: _buttonConfig[key].output, item: element})">
                                        <ng-container [ngTemplateOutletContext]="{$implicit: touchedDataElement}" [ngTemplateOutlet]="_buttonConfig[key].template"></ng-container>
                                    </span>
                                    <span 
                                        *ngIf="!_buttonConfig[key].hasOwnProperty('template')" 
                                        class="custom-button" 
                                        (click)="buttonClick.emit({button: _buttonConfig[key].output, item: element})">
                                        {{_buttonConfig[key].label}}
                                    </span>
                                </span>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="editIndex == i;">
                            <button *ngIf="_buttonConfig.confirm.show" class="table-button" [disabled]="!formValid" (click)="confirmChange();">
                                <mat-icon >done</mat-icon>
                            </button>
                            <mat-icon *ngIf="_buttonConfig.cancel.show" class="table-button" (click)="cancelChange(); buttonClick.emit({button: _buttonConfig.cancel.output, item: element})">close</mat-icon>
                        </ng-container>
                    </div>
                </mat-cell>
            </ng-container>
        
            <mat-header-row *matHeaderRowDef="_displayedColumns"></mat-header-row>
            <mat-row (mouseover)="mouseIndex = i;" (mouseleave)="mouseIndex = -1;" *matRowDef="let i = index; let row; columns: _displayedColumns;"></mat-row>
    
        </mat-table>
    </div>
    <mat-paginator [disabled]="editIndex != -1" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>

</fieldset>